module.exports = __webpack_public_path__ + "i18n/zh-TW.91b63273741ddc786aca32ab71cede14.json";